import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-salt-warning-dialog',
  templateUrl: './salt-warning-dialog.component.html',
  styleUrls: ['./salt-warning-dialog.component.css']
})
export class SaltWarningDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
